const planUpdatedEventType = 'planUpdated';

export function triggerPlanUpdated() {
    const planUpdatedEvent = new Event(planUpdatedEventType);
    document.dispatchEvent(planUpdatedEvent);
}

export function listenForPlanUpdate(callbackFn) {
    document.removeEventListener(planUpdatedEventType, callbackFn);
    document.addEventListener(planUpdatedEventType, callbackFn);
}
